export default __webpack_public_path__ + "static/media/31msP4ZPtmQ-HD.46a745f2.jpg";